import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(c, e) {
  return n(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 10.75c0-.414.53-.75 1.184-.75h12.632c.654 0 1.184.336 1.184.75s-.53.75-1.184.75H4.184C3.53 11.5 3 11.164 3 10.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const i = { render: t };
export {
  i as default,
  t as render
};
